module.exports = __webpack_public_path__ + "static/media/covi_org_tea.1294cd9f.png";